import styled from '@emotion/styled'
import { formatMoney } from '@sales-app/views/PotentialBooking/PotentialBooking/ActivitySection/RecommendedHomes/MapView/MapPopup/MapPopup.util'
import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'

import { Appeasement } from '@/types/User'

type Props = {
  appeasement: Appeasement
}

export const MobileAppeasement = ({ appeasement }: Props) => {
  const { category, reason, motivation, status, team, amount, createdAt } = appeasement

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const createdDate = createdAt ? formatInTimeZone(createdAt, timezone, 'yyyy-MM-dd') : ''

  return (
    <BoxStyled role="presentation">
      <p className="mb-1 text-p-sm">
        <strong>Amount:</strong> {formatMoney(amount, false)}
      </p>
      <div className="appeasement-information grid grid-cols-3">
        <div className="border-r border-secondary">
          <h6>Category</h6>
          <p>{category}</p>
        </div>
        <div className="border-r pl-2 border-secondary">
          <h6>Reason</h6>
          <p>{reason}</p>
        </div>
        <div className="pl-2">
          <h6>Motivation</h6>
          <p>{motivation}</p>
        </div>
      </div>
      <div className="appeasement-information mt-2 grid grid-cols-3">
        <div className="border-r border-secondary">
          <h6>Status</h6>
          <p>{status}</p>
        </div>
        <div className="border-r pl-2 border-secondary">
          <h6>Team</h6>
          <p>{team}</p>
        </div>
        <div className="pl-2">
          <h6>Created</h6>
          <p>{createdDate}</p>
        </div>
      </div>
    </BoxStyled>
  )
}

const BoxStyled = styled.div`
  padding: 0.75rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);

  .appeasement-information {
    div {
      display: flex;
      flex-direction: column;
    }

    h6 {
      color: #787573;
      font-size: var(--text-p-xs);
    }
    p {
      font-size: var(--text-p-xs);
      line-height: 1.8;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`
